export const socketId = (roomId, peerId) => {
  const roomIDX = roomId; //름 idx
  const userIDX = peerId; //응시자 idx
  const myRoomId = `${process.env.NEXT_PUBLIC_SITE_ID}` + "-" + roomIDX;
  const myPeerId =
    `${process.env.NEXT_PUBLIC_SITE_ID}` + "-" + roomIDX + "-" + userIDX;
  const con_my_peer_type = "TESTER";
  const peerViewMode = "CAMERA";

  return { myRoomId, myPeerId, con_my_peer_type, peerViewMode };
};
